import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'
import Plugin from '@/common/plugins'
import cookie from '@/common/utils/cookie'
import constant from '@/common/resources/constant'
import { isPrerenderer, checkEmergency } from '@/common/utils/common'
import pz from '@/common/utils/pz'
import { getEmergencyInfo } from '@/common/utils/request'
import { CONFIRM_EMERGENCY } from './common/resources/const'

Vue.config.productionTip = false

if (isPrerenderer()) {
  cookie.setItem('pz', JSON.stringify({ 'isPooqzone': false }), false, constant.URL_COOKIE_DOMAIN, '/')
} else {
  getEmergencyInfo().then(({ isEmergency }) => {
    if (isEmergency && sessionStorage.getItem(CONFIRM_EMERGENCY) !== 'y') {
      checkEmergency()
    } else {
      if (!cookie.wasSetWavveOn()) {
        pz.wavveOnCheck()
      }
    }
  })
}

Plugin.install()

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
